export class ReloadCallHistoryForUser {
   public static readonly type = '[Samwin CallHistory] reload call history for user';

   constructor(public userId: number, public numOfEntriesToLoad: number) {}
}
